import { NameField } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/ds-react-utils";
import { FormOptions, ScheduleOptions } from "./types";
import styled from "@emotion/styled";
import { useFormContext } from "react-hook-form";
import { TemplateSelection, SchedulingRadioGroup } from "@kaltura/mediaspace-shared-ui/controlled-form";
import { CustomRoomIllustration, roomIllustrationsMap } from "@kaltura/mediaspace-shared-ui";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";

export interface CreateRoomFormProps {
    fetchFormOptions: () => FormOptions;
    onSubmit: (data: { [key: string]: string | boolean }) => Promise<void>;
}

const StyledForm = styled("form")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

const baseClassName = "kms-ds-create-room-modal-content-form";

const CreateRoomForm = (props: CreateRoomFormProps) => {
    const { fetchFormOptions, onSubmit } = props;
    const { handleSubmit } = useFormContext();

    const { templates, timezones } = fetchFormOptions();

    return (
        <StyledForm className={baseClassName} onSubmit={handleSubmit(onSubmit)} noValidate>
            <NameField id={"name"} label={translate("Name")} className={`${baseClassName}-name`} />
            <ButtonAnalyticsProvider namePrefix={"Toggle Room template -"}>
                <TemplateSelection
                    id={"roomMode"}
                    labelSingle={translate("Your room mode")}
                    labelMultiple={translate("Room mode")}
                    templates={templates}
                    defaultIllustration={CustomRoomIllustration}
                    illustrationsMap={roomIllustrationsMap}
                />
            </ButtonAnalyticsProvider>
            <SchedulingRadioGroup
                label={translate("Room availability")}
                falseLabel={translate("Always open")}
                trueLabel={translate("Specific time frame")}
                fieldName="roomSchedulingType"
                timezones={timezones}
                falseValue={ScheduleOptions.ALWAYS}
                trueValue={ScheduleOptions.SCHEDULED}
                getAnalyticsLabel={(isScheduled) => `Toggle Room availability - ${isScheduled ? "Schedule" : "Always"}`}
            />
            {/* connecting this form to the submit button outside of it using 'form' prop
            won't trigger a submit on enter key press, so using a hidden submit button */}
            <input type="submit" hidden aria-hidden="true" />
        </StyledForm>
    );
};

export default CreateRoomForm;
